import { Link } from 'react-router-dom';
import { ButtonVariants } from '@components/button/Button';
import { Icon } from '@components/icon/Icon';
import { LinkStyledAsButton } from '@components/linkStyledAsButton/LinkStyledAsButton';
import { useAbortEffect } from '@shared/hooks/useAbortEffect';
import { OPERATIONS_BULLETIN_BOARD_CREATE_PATH } from 'restaurantAdmin/paths';
import typography from '~styles/typography.scss';
import { useRestaurant } from '../../context/useRestaurant';
import { PageContent } from '../../layout/PageContent';
import { PageHeader } from '../../layout/PageHeader';
import { getRestaurantBulletins } from './apiHelpers';
import { RestaurantBulletinsList } from './RestaurantBulletinsList';
import styles from './RestaurantBulletinsPage.scss';

export const RestaurantBulletinsPage = () => {
  const { id: restaurantId } = useRestaurant();

  const { data: restaurantBulletins = [], rerun: refresh } = useAbortEffect(
    {
      effect: () => getRestaurantBulletins(restaurantId),
      throwOnError: true,
    },
    [restaurantId],
  );

  return (
    <>
      <PageHeader title="Bulletins" category="Operations">
        <LinkStyledAsButton
          label="Add New Bulletin"
          to={OPERATIONS_BULLETIN_BOARD_CREATE_PATH}
          variant={ButtonVariants.Secondary}
        />
      </PageHeader>
      <PageContent>
        <div className={styles.mainContent}>
          <p className={typography.c2}>
            Bulletins will display on the discover page for your restaurant.
            Only one bulletin is displayed at a time. If two or more bulletins
            are scheduled to display at the same time, the least frequent
            bulletin will be the one displayed on the discover page.
          </p>
          {restaurantBulletins.length ? (
            <RestaurantBulletinsList
              restaurantBulletins={restaurantBulletins}
              refetchRestaurantBulletins={refresh}
            />
          ) : (
            <p className={typography.c2}>No bulletins found.</p>
          )}
          <Link
            to={OPERATIONS_BULLETIN_BOARD_CREATE_PATH}
            className={styles.newBulletinButton}
          >
            <span className={typography.h7}>Add new bulletin</span>
            <Icon name="plus" />
          </Link>
        </div>
      </PageContent>
    </>
  );
};
